export const propertyTypes = [
  {
    id: 'SINGLE_FAMILY',
    label: 'Single Family',
    icon: 'house-door',
    value: 'SINGLE_FAMILY',
    cashOffer: 'SINGLE_FAMILY_HOME'
  },
  {
    id: 'CONDOMINIUM',
    label: 'Condominium',
    icon: 'building',
    value: 'CONDOMINIUM',
    cashOffer: 'CONDOMINIUM'
  },
  {
    id: 'TOWNHOME',
    label: 'Townhouse',
    icon: 'house',
    value: 'TOWNHOUSE',
    cashOffer: 'TOWNHOME'
  },
  {
    id: 'MULTI_FAMILY',
    label: 'Multi Family',
    icon: 'house',
    value: 'MULTI_FAMILY',
    cashOffer: 'MULTI_FAMILY'
  },
  {
    id: 'MANUFACTURED_HOME',
    label: 'Manufactured Home',
    icon: 'house-door',
    value: 'MOBILE_HOME',
    cashOffer: 'MANUFACTURED_HOME'
  },
  {
    id: 'LAND',
    label: 'Land',
    icon: 'dash',
    value: 'VACANT_LOT',
    cashOffer: 'LAND'
  },
  {
    id: 'COMMERCIAL',
    label: 'Commercial',
    icon: 'graph-up',
    value: 'COMMERCIAL',
    cashOffer: 'COMMERCIAL'
  },
  {
    id: 'OTHER',
    label: 'Other',
    icon: '',
    value: 'OTHER',
    cashOffer: 'OTHER'
  }
]